import { render, staticRenderFns } from "./10.vue?vue&type=template&id=ae6edc50&scoped=true&"
import script from "./10.vue?vue&type=script&lang=js&"
export * from "./10.vue?vue&type=script&lang=js&"
import style0 from "./10.vue?vue&type=style&index=0&id=ae6edc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6edc50",
  null
  
)

export default component.exports